import { toast } from 'vue3-toastify'

const TOAST_TYPE_BY_KEY = {
  notice: 'success',
  success: 'success',
  alert: 'warning',
  warning: 'warning',
  error: 'error'
}

export default function showFlashes() {
  document.querySelectorAll('.flashes > [data-key]').forEach((el) => {
    const message = el.textContent.trim()
    if (message) {
      const type = TOAST_TYPE_BY_KEY[el.dataset.key] || 'info'
      toast[type](message)
    }
    el.remove()
  })
}
